export default __webpack_public_path__ + "static/media/ArrowRight.afdc0317.svg";